import {analytics} from '../services'
const hotjarID = 2385738
const hotjarSV = 6

function createAndInjectDynamicScript({
  async = true,
  attachTo = 'head',
  onLoadCallback = null,
  src = '',
}) {
  const [hostElement] = document.getElementsByTagName(attachTo)
  const script = document.createElement('script')
  script.async = async

  if (onLoadCallback && typeof onLoadCallback === 'function') {
    script.addEventListener('load', onLoadCallback)
  }

  script.src = src
  hostElement.appendChild(script)
}

export function includeHotjar() {
  window.hj =
    window.hj ||
    function () {
      ;(window.hj.q = window.hj.q || []).push(arguments)
    }

  try {
    createAndInjectDynamicScript({
      onLoadCallback: hotjarInstance => {
        hotjarInstance('identify', null, {hjid: hotjarID, hjsv: hotjarSV})
        analytics.event('action/hotjarInstance', {
          loadCallBack: hotjarInstance ? typeof onLoadCallback : null,
        })
      },
      src: `https://static.hotjar.com/c/hotjar-${hotjarID}.js?sv${hotjarSV}`,
    })
  } catch (error) {
    analytics.report(error, {
      error: error,
    })
  }
  return window.hj
}
